module.exports = __webpack_public_path__ + "static/media/airtime.1a4ef75e.svg";